const setCssSize = (factor: number | string) => ({
  width: factor,
  height: factor,
});

export default setCssSize;
